import _objectSpread from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/web.dom-collections.for-each.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { saveFile, valsubstr32addbr } from '@/utils';
import NoData from '@/components/NoData/NoData';
export default {
  name: 'userRole',
  components: {
    NoData: NoData
  },
  data: function data() {
    return {
      formInline: {
        ruleName: null,
        ruleStatus: null,
        systemIdList: null
      },
      showLoading: false,
      tableData: [],
      tableheight: 0,
      delChecked: false,
      total: 0,
      pageNum: 1,
      pageSize: 10,
      systemList: [],
      status: {
        ACTIVE: '有效',
        INACTIVE: '无效'
      },
      ruleIdList: [],
      delSelectList: []
    };
  },
  inject: ['dict_info'],
  mounted: function mounted() {
    this.$nextTick(function () {
      this.tableheight = window.innerHeight - 320;

      // 监听窗口大小变化
      var self = this;
      window.onresize = function () {
        self.tableheight = window.innerHeight - 320;
      };
    });
  },
  created: function created() {
    this.init();
  },
  methods: {
    resetSearch: function resetSearch() {
      this.formInline = Object.assign(this.formInline, {
        ruleName: null,
        ruleStatus: null,
        systemIdList: null
      });
      this.getRuleInfo();
    },
    setSelect: function setSelect(row) {
      return !!row.delRule;
    },
    getDelList: function getDelList(ruleId) {
      this.ruleIdList = [];
      this.ruleIdList.push(ruleId);
      this.delRule();
    },
    downLoad: function downLoad() {
      var data = _objectSpread({
        pageNum: -1,
        pageSize: -1
      }, this.formInline);
      this.$API.postRequest({
        url: '/platform/userRule/roleInfo',
        data: data,
        responseType: 'blob'
      }).then(function (res) {
        // let fileName = window.decodeURI(res.headers['content-disposition'])
        // let finannlname = fileName.split('=')[1];
        saveFile(res.data, '用户打标规则信息.xlsx');
      });
    },
    delRule: function delRule() {
      var _this = this;
      this.showLoading = true;
      this.$API.delRequest({
        url: '/platform/userRule/ruleId',
        data: {
          ruleIdList: this.ruleIdList
        }
      }).then(function (res) {
        _this.showLoading = false;
        if (res.code === '0000000000') {
          _this.$message({
            message: '规则删除成功！',
            type: 'success'
          });
          _this.init();
        }
      });
    },
    getRule: function getRule(ruleId, edit) {
      var _this2 = this;
      this.showLoading = true;
      this.$API.getRequest({
        url: '/platform/userRule/ruleId',
        data: {
          edit: edit,
          ruleId: ruleId
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this2.showLoading = false;
          _this2.$store.dispatch('system/setRuleInfo', res.result);
          _this2.$router.push({
            name: 'editRule',
            query: {
              isEdit: edit ? 1 : 0
            }
          });
        }
      });
    },
    addRule: function addRule() {
      this.$store.dispatch('system/setRuleInfo', null);
      this.$router.push({
        path: '/system/editRule',
        query: {
          isEdit: 0,
          isAdd: 1
        },
        params: {
          systemList: this.systemList
        }
      });
    },
    init: function init() {
      this.getSystem();
      this.getRuleInfo();
    },
    getSystem: function getSystem() {
      var _this3 = this;
      this.showLoading = true;
      this.$API.getRequest({
        url: '/platform/systemInner/list'
      }).then(function (res) {
        _this3.showLoading = false;
        if (res.code === '0000000000') {
          _this3.systemList = res.result.records;
        }
      });
    },
    getRuleInfo: function getRuleInfo() {
      var _this4 = this;
      this.showLoading = true;
      this.$API.postRequest({
        url: '/platform/userRule/ruleInfo',
        data: _objectSpread({
          pageNum: this.pageNum,
          pageSize: this.pageSize
        }, this.formInline)
      }).then(function (res) {
        _this4.showLoading = false;
        if (res.code === '0000000000') {
          _this4.tableData = res.result.records;
          _this4.total = res.result.total;
        }
      });
    },
    ToBreak: function ToBreak(val) {
      if (val) {
        return valsubstr32addbr(val);
      }
    },
    headerdragend: function headerdragend(newWidth, oldWidth, column) {
      if (newWidth < column.minWidth) {
        column.width = column.minWidth;
      }
    },
    handleSelectionChange: function handleSelectionChange(val) {
      this.delSelectList = val;
    },
    selectAll: function selectAll() {},
    currentChange: function currentChange(page) {
      this.pageNum = page;
      this.getRuleInfo();
    },
    sizeChange: function sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.getRuleInfo();
    },
    delSelect: function delSelect() {
      var _this5 = this;
      var ruleIdList = [];
      this.delSelectList.forEach(function (ele) {
        ruleIdList.push(ele.ruleId);
      });
      this.$API.delRequest({
        url: '/platform/userRule/ruleId',
        data: {
          ruleIdList: ruleIdList
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          _this5.$message({
            message: '删除成功！',
            type: 'success'
          });
          _this5.getRuleInfo();
        }
      });
    }
  }
};